import { AnyAction, Reducer } from 'redux';
import { DEFAULT_ADMISSION_FORM_VALUE, PROCEDURE_OTHER_TYPES } from '../../shared/constants/crmConstants';

import { NewAdmissionState } from '../models/newAdmissionModel';
import actionTypes from '../types/newAdmissionTypes';
import { cloneDeep } from 'lodash';
import { getDefaultTimeline } from '../../utils/dateTimeUtils';

const defaultInitialState = {
  aadhaarOtp: '',
  aadhaarResponse: '',
  abhaAuthModeFail: false,
  abhaAuthModes: [],
  abhaIdOtpVerificationError: false,
  abhaIdVerifiedData: {},
  aadharNumberValue: '',
  aadharVerificationSuccess: false,
  additionalAdmissionInfo: {
    admissionStartTime: null,
  },
  additionalMandatoryDocuments: [],
  adhaarLoading: false,
  adhaarVerified: false,
  admissionFormType: '',
  admissionFormVal: cloneDeep(DEFAULT_ADMISSION_FORM_VALUE),
  ailmentValue: [],
  allowNextStage: true,
  autoFillDayCareProcedure: false,
  automatedProcedureId: 0,
  automatedProcedureOptions: [...PROCEDURE_OTHER_TYPES],
  autoSimulationpackages: [
    {
      'package_Name': 'Cataract removal - 27,500',
      'packageId': 873434,
      'perP_PER_ID': 0,
      'general_Ward': 53550,
      'private_Ward': 63000,
      'semi_Private_Ward': 56700,
      'deluxe_Other': 0,
      'discount': 0,
      'peR_PackageAlias': 'Cataract',
      'packageType': null,
      'package_Start_date': '0001-01-01T00:00:00',
      'package_Expiry_date': '0001-01-01T00:00:00',
      'isPendingForApproval': false,
      'distinctPrices': null,
      'packageTagName': null,
      'icD_Name': 'H25',
      'packageCost': 27500,
      'is_Per_Day_Eligible_Package': null,
      'value': '165485842345919',
      'name': 'Cataract removal - 27,500',
    },
    {
      'package_Name': 'Cataract removal - 28,000',
      'packageId': 873435,
      'perP_PER_ID': 0,
      'general_Ward': 0,
      'private_Ward': 0,
      'semi_Private_Ward': 0,
      'deluxe_Other': 0,
      'discount': 0,
      'peR_PackageAlias': 'Cataract',
      'packageType': null,
      'package_Start_date': '0001-01-01T00:00:00',
      'package_Expiry_date': '0001-01-01T00:00:00',
      'isPendingForApproval': false,
      'distinctPrices': null,
      'packageTagName': null,
      'icD_Name': 'H25',
      'packageCost': 28000,
      'is_Per_Day_Eligible_Package': null,
      'value': '165485842345920',
      'name': 'Cataract removal - 28,000',
    },
  ],
  beneficiaryList: [],
  beneficiarySearchResponsePayerId: 0,
  beneficiarySearchResponsePayerName: '',
  beneficiaryStatus: '',
  billAmountArray: [],
  billdetailValues: {},
  cardCollapse: {
    isMaternityOpen: false,
    isOtherTreatmentDetailOpen: false,
    isCovidCaseCardOpen: false,
    selectedDiagnosisIds: [],
  },
  checkAll: false,
  checkedFileList: [],
  checkedHISFiles: [],
  claimDetailBackup: null,
  classificationArray: [],
  clickedOnSkip: false,
  conditionOnDischargeValue: '',
  consentDateTime: {},
  consentOption: '',
  consentOptionStyle: {},
  createAbhaAlreadyExist: false,
  defaultClaim: false,
  defaultTimeline: getDefaultTimeline(),
  diagnosisSelectedValues: [],
  disableRoomType: false,
  dlVerified: false,
  doaValue: '',
  dobLoading: false,
  dobModalVisible: false,
  documentType: false,
  documentUploadSuccess: false,
  downloadDocumentGuidList: [],
  draftFormValidated: false,
  draftValue: '',
  dynamicQuestionFields: [],
  enableAadhar: false,
  enableAadhaarOtp: false,
  enableMobileOtp: false,
  encryptedTxn: '',
  existingClaimError: {},
  extraFormValues: {},
  finalMandatoryClassifications: [],
  formAction: '',
  getHealthIdCard: false,
  goToNext: false,
  govtSchemeUrn: undefined,
  healthbankUserSignupOption: '',
  healthCardType: '',
  healthVaultDocumentUpload: false,
  healthVaultEnable: false,
  hidConfirmationMessage: '',
  hisFileSize: 0,
  hospActionID: '',
  isDischargeCase: false,
  isCovidCase: false,
  isDelayedAdmission: false,
  showOtherProcedure: false,
  showOtherRoomType: false,
  hospDetailsForRoomType: {},
  hospitalOtherRoomType: '',
  hospitalWisePayerList: [],
  hospitalizationDuration: undefined,
  hyphenatedBasedGroupPolicy: false,
  isAbhaVerified: false,
  isArtemis: false,
  isBeneficiaryPopUpRequired: false,
  isBeneficiarySelected: false,
  isComeFromSubmit: false,
  isComponentRendered: false,
  isDaycareCase: false,
  isDateApplied: false,
  isDeathCase: false,
  isDraftSelected: false,
  isFileProcessInProgress: false,
  isFileUploadEnabledForce: false,
  isIPNumberPopUpEnabled: false,
  isLOSgt90: false,
  isLoadingAuthenticate: false,
  isLoadingPreData: false,
  isManualSubmission: false,
  isMinimize: true,
  isNewBornCase: false,
  isPageChangeAllowed: true,
  isShowAdmissionForm: false,
  isShowingDoADoDEnhancementModal: false,
  isSubmiClickedFromModal: false,
  isSubmitClicked: false,
  isSuccessModalNewAdmission: false,
  linkAbhaClick: false,
  mappedAilmentValues: [],
  maximumFileSizeAllowed: 15,
  memberId: null,
  memberSearchId: null,
  memberSearchRequest: {},
  mobileNumberValue: '',
  mobileOnScreen: false,
  mobileOtp: '',
  mobileVerification: false,
  modalFormValue: {},
  modalSwitchDisabled: false,
  nameAdhaarVerified: false,
  newAdmissionSearchValues: {},
  newHealthBankUserId: '',
  nonAvailableClassification: [],
  nonSelectedDiscrepency: '',
  openFileDialogOnClick: false,
  panCardNumber: undefined,
  panNoVerified: false,
  panRequired: false,
  panVerificationRequired: false,
  panVerified: false,
  patientConsentProceedClicked: false,
  patientSignature: [],
  payerDocs: [],
  percent: 100,
  percentageNameMatch: undefined,
  pltMappedValue: '',
  previouslyUploadedFiles: [],
  procedureSelectedValues: [],
  proposedLineTreatmentId: 0,
  isPLTChanged: false,
  resetDetailNav: 0,
  searchType: null,
  showAccidentCard : false,
  selectedAilmentValues: [],
  selectedBeneficiaryDetail: null,
  selectedCenter: null,
  selectedCorporateName: undefined,
  selectedDiscrepency: '',
  selectedDoctorList: {},
  selectedDraft: {},
  selectedFiles: [],
  selectedHISFiles: [],
  selectedInsurerId: undefined,
  selectedMemberCardIndex: -1,
  selectedOption: '',
  selectedPackage: undefined,
  selectedTab: -1,
  settlementModal: false,
  settlementType: '',
  showAbhaLinkModal: false,
  showBeneficiaryCard: true,
  showCsvMismatchModal: false,
  showOtherMinimize: true,
  showPayerNotConfiguredMessage: false,
  showPayerUpdatedMessage: false,
  showProbability: 0,
  showShareDocumentOptionsModal: false,
  specialityOptions: [],
  starDisabledBenefMessage: '',
  statusName: '',
  submitDisabled: true,
  submitWarn: false,
  submitWithoutDocsClicked: false,
  successModalVisible: false,
  tempProfile: {},
  toggleClick: false,
  txnID: '',
  txnId: '',
  updatedFiles: [],
  updatedMemberName: '',
  updatedVisibleLetters: [],
  uploadedFileList: [],
  uploadedFiles: [],
  uploadedFilesGUID: [],
  uploadedFilesName: [],
  uploadedFileTypes: [],
  userPresent: false,
  userProfilesArray: [],
  usersNotFound: false,
  verificationModalVisible: false,
  voterIDVerified: false,
};

const initialState: NewAdmissionState = cloneDeep(defaultInitialState);

const setSelectedTab = (state: NewAdmissionState, { selectedTab }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedTab },
});

const setProcedureID = (state: NewAdmissionState, { automatedProcedureId }: AnyAction): NewAdmissionState => ({
  ...state, ...{ automatedProcedureId },
});

const setAilmentValues = (state: NewAdmissionState, { selectedAilmentValues }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedAilmentValues },
});

const setMappedAilmentValues = (state: NewAdmissionState, { mappedAilmentValues }: AnyAction): NewAdmissionState => ({
  ...state, ...{ mappedAilmentValues },
});

const setPltID = (state: NewAdmissionState, { proposedLineTreatmentId }: AnyAction): NewAdmissionState => ({
  ...state, ...{ proposedLineTreatmentId },
});

const setAdmissionFormVal = (state: NewAdmissionState, { admissionFormVal }: AnyAction): NewAdmissionState => ({
  ...state, ...{ admissionFormVal },
});

const setIsShowAdmissionForm = (state: NewAdmissionState, { isShowAdmissionForm }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isShowAdmissionForm },
});

const setInsurerID = (state: NewAdmissionState, { selectedInsurerId }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedInsurerId },
});
const setCorporateName = (state: NewAdmissionState, { selectedCorporateName }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedCorporateName },
});

const setAdditionalAdmissionInfoRed = (state: NewAdmissionState, { additionalAdmissionInfo }: AnyAction): NewAdmissionState => ({
  ...state, ...{ additionalAdmissionInfo },
});

const setBeneficiaryList = (state: NewAdmissionState, { beneficiaryList }: AnyAction): NewAdmissionState => ({
  ...state, ...{ beneficiaryList, isManualSubmission: false },
});

const setHISBenefSearchRequestObj = (state: NewAdmissionState, { memberSearchRequest }: AnyAction): NewAdmissionState => ({
  ...state, ...{ memberSearchRequest },
});

const clearState = (): NewAdmissionState => cloneDeep(defaultInitialState);

const setSelectedBeneficiary = (state: NewAdmissionState, { beneficiary }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedBeneficiaryDetail: beneficiary, isBeneficiarySelected: !!beneficiary },
});

const setClaimDetailBackup = (state: NewAdmissionState, { payload }: AnyAction): NewAdmissionState => ({
  ...state, ...{ claimDetailBackup: payload },
});

const setSelectedBenfStatus = (state: NewAdmissionState, { beneficiaryStatus }: AnyAction): NewAdmissionState => ({
  ...state, ...{ beneficiaryStatus },
});

const setUploadedFiles = (state: NewAdmissionState, { uploadedFiles }: AnyAction): NewAdmissionState => ({
  ...state, ...{ uploadedFiles },
});

const setPayerDocs = (state: NewAdmissionState, {payerDocs}: AnyAction): NewAdmissionState => ({
  ...state, ...{payerDocs},
});

const setToggleClick = (state: NewAdmissionState, { toggleClick }: AnyAction): NewAdmissionState => ({
  ...state, ...{ toggleClick },
});
const setFileDialogOpen = (state: NewAdmissionState, { openFileDialogOnClick }: AnyAction): NewAdmissionState => ({
  ...state, ...{ openFileDialogOnClick },
});
const setLinkAbhaClick = (state: NewAdmissionState, { linkAbhaClick }: AnyAction): NewAdmissionState => ({
  ...state, ...{ linkAbhaClick },
});
const setMaxSizeForFile = (state: NewAdmissionState, { maximumFileSizeAllowed }: AnyAction): NewAdmissionState => ({
  ...state, ...{ maximumFileSizeAllowed },
});
const setMobileOnScreen = (state: NewAdmissionState, { mobileOnScreen }: AnyAction): NewAdmissionState => ({
  ...state, ...{ mobileOnScreen },
});
const setShowShareDocumentOptionsModal = (state: NewAdmissionState, { showShareDocumentOptionsModal }: AnyAction): NewAdmissionState => ({
  ...state, ...{ showShareDocumentOptionsModal },
});
const setHealthBankUser = (state: NewAdmissionState, { newHealthBankUserId }: AnyAction): NewAdmissionState => ({
  ...state, ...{ newHealthBankUserId },
});
const setShowAbhaLinkModal = (state: NewAdmissionState, { showAbhaLinkModal }: AnyAction): NewAdmissionState => ({
  ...state, ...{ showAbhaLinkModal },
});
const setHealthbankUserSignupOption = (state: NewAdmissionState, { healthbankUserSignupOption }: AnyAction): NewAdmissionState => ({
  ...state, ...{ healthbankUserSignupOption },
});
const setDocumentUploadSuccess = (state: NewAdmissionState, { documentUploadSuccess }: AnyAction): NewAdmissionState => ({
  ...state, ...{ documentUploadSuccess },
});
// documentUploadSuccess
const setMobileVerification = (state: NewAdmissionState, { mobileVerification }: AnyAction): NewAdmissionState => ({
  ...state, ...{ mobileVerification },
});
const setHealthVaultEnable = (state: NewAdmissionState, { healthVaultEnable }: AnyAction): NewAdmissionState => ({
  ...state, ...{ healthVaultEnable },
});
const setHealthVaultDocumentUpload = (state: NewAdmissionState, { healthVaultDocumentUpload }: AnyAction): NewAdmissionState => ({
  ...state, ...{ healthVaultDocumentUpload },
});
const setUserPresent = (state: NewAdmissionState, { userPresent }: AnyAction): NewAdmissionState => ({
  ...state, ...{ userPresent },
});
const setUsersNotFound = (state: NewAdmissionState, { usersNotFound }: AnyAction): NewAdmissionState => ({
  ...state, ...{ usersNotFound },
});
const setCheckAllDocs = (state: NewAdmissionState, { checkAll }: AnyAction): NewAdmissionState => ({
  ...state, ...{ checkAll },
});
const setEnableAadhar = (state: NewAdmissionState, { enableAadhar }: AnyAction): NewAdmissionState => ({
  ...state, ...{ enableAadhar },
});
const setEnableMobileOTP = (state: NewAdmissionState, { enableMobileOtp }: AnyAction): NewAdmissionState => ({
  ...state, ...{ enableMobileOtp },
});
const setEnableAadhaarOTP = (state: NewAdmissionState, { enableAadhaarOtp }: AnyAction): NewAdmissionState => ({
  ...state, ...{ enableAadhaarOtp },
});
const setAadharVerficationSuccess = (state: NewAdmissionState, { aadharVerificationSuccess }: AnyAction): NewAdmissionState => ({
  ...state, ...{ aadharVerificationSuccess },
});
const setMobileNo = (state: NewAdmissionState, { mobileNumberValue }: AnyAction): NewAdmissionState => ({
  ...state, ...{ mobileNumberValue },
});
const setTempProfile = (state: NewAdmissionState, { tempProfile }: AnyAction): NewAdmissionState => ({
  ...state, ...{ tempProfile },
});
const setSelectedDoctorList = (state: NewAdmissionState, { selectedDoctorList }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedDoctorList },
});
const setPatientSignature = (state: NewAdmissionState, { patientSignature }: AnyAction): NewAdmissionState => ({
  ...state, ...{ patientSignature },
});
const setEncryptedTxn = (state: NewAdmissionState, { encryptedTxn }: AnyAction): NewAdmissionState => ({
  ...state, ...{ encryptedTxn },
});
const setTxnId = (state: NewAdmissionState, { txnID }: AnyAction): NewAdmissionState => ({
  ...state, ...{ txnID },
});
const setHospActionId = (state: NewAdmissionState, { hospActionID }: AnyAction): NewAdmissionState => ({
  ...state, ...{ hospActionID },
});
const setDOA = (state: NewAdmissionState, { doaValue }: AnyAction): NewAdmissionState => ({
  ...state, ...{ doaValue },
});
const setMobileOTP = (state: NewAdmissionState, { mobileOtp }: AnyAction): NewAdmissionState => ({
  ...state, ...{ mobileOtp },
});
const setAadhaarOTP = (state: NewAdmissionState, { aadhaarOtp }: AnyAction): NewAdmissionState => ({
  ...state, ...{ aadhaarOtp },
});
const setAadharNo = (state: NewAdmissionState, { aadharNumberValue }: AnyAction): NewAdmissionState => ({
  ...state, ...{ aadharNumberValue },
});

const setIsMinimize = (state: NewAdmissionState, { isMinimize }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isMinimize },
});

const setShowOtherMinimize = (state: NewAdmissionState, { showOtherMinimize }: AnyAction): NewAdmissionState => ({
  ...state, ...{ showOtherMinimize },
});

const setIsModal = (state: NewAdmissionState, { settlementModal }: AnyAction): NewAdmissionState => ({
  ...state, ...{ settlementModal },
});

const updateDraftValue = (state: NewAdmissionState, { draftValue }: AnyAction): NewAdmissionState => ({
  ...state, ...{ draftValue },
});

const setbillAmountArray = (state: NewAdmissionState, { billAmountArray }: AnyAction): NewAdmissionState => ({
  ...state, ...{ billAmountArray },
});

const setClassificationArray = (state: NewAdmissionState, { classificationArray }: AnyAction): NewAdmissionState => ({
  ...state, ...{ classificationArray },
});
const setUserProfiles = (state: NewAdmissionState, { userProfilesArray }: AnyAction): NewAdmissionState => ({
  ...state, ...{ userProfilesArray },
});
const setFileNames = (state: NewAdmissionState, { uploadedFilesName }: AnyAction): NewAdmissionState => ({
  ...state, ...{ uploadedFilesName },
});
const setFileGUID = (state: NewAdmissionState, { uploadedFilesGUID }: AnyAction): NewAdmissionState => ({
  ...state, ...{ uploadedFilesGUID },
});
const setFileTypes = (state: NewAdmissionState, { uploadedFileTypes }: AnyAction): NewAdmissionState => ({
  ...state, ...{ uploadedFileTypes },
});
const setDocumentList = (state: NewAdmissionState, { uploadedFileList }: AnyAction): NewAdmissionState => ({
  ...state, ...{ uploadedFileList },
});
const setCheckedList = (state: NewAdmissionState, { checkedFileList }: AnyAction): NewAdmissionState => ({
  ...state, ...{ checkedFileList },
});

const setNonAvailableClassification = (state: NewAdmissionState, { nonAvailableClassification }: AnyAction): NewAdmissionState => ({
  ...state, ...{ nonAvailableClassification },
});

const setFinalMandatoryClassifications = (state: NewAdmissionState, { finalMandatoryClassifications }: AnyAction): NewAdmissionState => ({
  ...state, ...{ finalMandatoryClassifications },
});

const setIsFileProcessInProgress = (state: NewAdmissionState, { isFileProcessInProgress }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isFileProcessInProgress },
});

const setPercent = (state: NewAdmissionState, { percent }: AnyAction): NewAdmissionState => ({
  ...state, ...{ percent },
});

const setGoToNext = (state: NewAdmissionState, { goToNext }: AnyAction): NewAdmissionState => ({
  ...state, ...{ goToNext },
});

const setClickedOnSkip = (state: NewAdmissionState, { clickedOnSkip }: AnyAction): NewAdmissionState => ({
  ...state, ...{ clickedOnSkip },
});

const setPatientConsentProceedClicked = (state: NewAdmissionState, { patientConsentProceedClicked }: AnyAction): NewAdmissionState => ({
  ...state, ...{ patientConsentProceedClicked },
});

const setSelectedConsentOptions = (state: NewAdmissionState, { consentOption }: AnyAction): NewAdmissionState => ({
  ...state, ...{ consentOption },
});

const setSelectedConsentOptionStyle = (state: NewAdmissionState, { consentOptionStyle }: AnyAction): NewAdmissionState => ({
  ...state, ...{ consentOptionStyle },
});

const setConsentDateTime = (state: NewAdmissionState, { consentDateTime }: AnyAction): NewAdmissionState => ({
  ...state, ...{ consentDateTime },
});

const setIsComeFromSubmit = (state: NewAdmissionState, { isComeFromSubmit }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isComeFromSubmit },
});

const setIsSubmitted = (state: NewAdmissionState, { isSubmitClicked }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isSubmitClicked },
});

const setIsSuccessModalNewAdmissionClicked = (state: NewAdmissionState, { isSuccessModalNewAdmission }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isSuccessModalNewAdmission },
});

const setCardCollapse = (state: NewAdmissionState, { cardCollapse }: AnyAction): NewAdmissionState => ({
  ...state, ...{ cardCollapse },
});

const updatePackageSelection = (state: NewAdmissionState, { selectedPackage }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedPackage },
});

const setExtraFormValues = (state: NewAdmissionState, { extraFormValues }: AnyAction): NewAdmissionState => ({
  ...state, ...{ extraFormValues },
});

const setIsLoadingPreData = (state: NewAdmissionState, { isLoadingPreData }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isLoadingPreData },
});

const setMemberName = (state: NewAdmissionState, { memberName }: AnyAction): NewAdmissionState => ({
  ...state, ...{ updatedMemberName: memberName },
});

const setAbhIdVerified = (state: NewAdmissionState, { isAbhaVerified, abhaIdVerifiedData }: AnyAction): NewAdmissionState => ({
  ...state,
  isAbhaVerified,
  abhaIdVerifiedData,
  abhaAuthModes:
    Object.keys(abhaIdVerifiedData).length > 0
      ? state.abhaAuthModes : initialState.abhaAuthModes,
});

const manualSubmissionEnable = (state: NewAdmissionState): NewAdmissionState => ({
  ...state, ...{ isManualSubmission: true },
});

const setIsDraftSelected = (state: NewAdmissionState, { isDraftSelected }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isDraftSelected },
});

const setSelectedDraftReducer = (state: NewAdmissionState, { selectedDraft }: AnyAction): NewAdmissionState => ({
  ...state, ...{ selectedDraft },
});

const setHospitalWisePayerListReducer = (state: NewAdmissionState, { hospitalWisePayerList }: AnyAction): NewAdmissionState => ({
  ...state, ...{ hospitalWisePayerList },
});

const setIsComponentRendered = (state: NewAdmissionState, { isComponentRendered }: AnyAction): NewAdmissionState => ({
  ...state, ...{ isComponentRendered },
});

const clearSelectedPackage = (state: NewAdmissionState, { }: AnyAction): NewAdmissionState => {
  return {
    ...state,
    ...{
      admissionFormVal: {
        ...state.admissionFormVal,
        billDetail: {
          ...state.admissionFormVal.billDetail,
          searchPackage: undefined,
          Package: undefined,
        },
      },
    },
  };
};

const updateBillFields = (state: NewAdmissionState, action: AnyAction): NewAdmissionState => {
  return {
    ...state,
    admissionFormVal: {
      ...state.admissionFormVal,
      billDetail: action.payload,
    },
  };
};

const updateModalFormValues = (state: NewAdmissionState, { modalFormValue }: AnyAction): NewAdmissionState => ({
  ...state,
  modalFormValue,
});

const setNewAdmissionSearchValues = (state: NewAdmissionState, { newAdmissionSearchValues }: AnyAction): NewAdmissionState => ({
  ...state, ...{ newAdmissionSearchValues },
});

const setBillDetailValues = (state: NewAdmissionState, { billdetailValues }: AnyAction): NewAdmissionState => ({
  ...state, ...{ billdetailValues },
});

const reducer: Reducer<NewAdmissionState> = (
  state: NewAdmissionState = initialState,
  action: AnyAction,
): NewAdmissionState | any => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_TAB:
      return setSelectedTab(state, action);
    case actionTypes.SET_AUTOMATED_PROCEDURE_ID:
      return setProcedureID(state, action);
    case actionTypes.SET_SELECTED_AILMENT_VALUES:
      return setAilmentValues(state, action);
    case actionTypes.SET_MAPPED_AILMENT_VALUES:
      return setMappedAilmentValues(state, action);
    case actionTypes.SET_PLT_ID:
      return setPltID(state, action);
    case actionTypes.SET_ADMISSION_FORM_VAL:
      return setAdmissionFormVal(state, action);
    case actionTypes.SET_IS_SHOW_ADMISSION_FORM:
      return setIsShowAdmissionForm(state, action);
    case actionTypes.SET_SELECTED_INSURER_ID:
      return setInsurerID(state, action);
    case actionTypes.SET_CORPORATE_NAME:
      return setCorporateName(state, action);
    case actionTypes.SET_ADDITIONAL_ADMISSION_INFO:
      return setAdditionalAdmissionInfoRed(state, action);
    case actionTypes.SET_BENEFICIARY_LIST:
      return setBeneficiaryList(state, action);
    case actionTypes.SET_BENEFICIARY_REQUEST_OBJECT:
      return setHISBenefSearchRequestObj(state, action);
    case actionTypes.CLEAR_STATE:
      return clearState();
    case actionTypes.SELECT_BENEFICIARY:
      return setSelectedBeneficiary(state, action);
    case actionTypes.SELECT_CLAIMDETAIL_BACKUP:
      return setClaimDetailBackup(state, action);
    case actionTypes.SELECTED_BENEFICIARY_STATUS:
      return setSelectedBenfStatus(state, action);
    case actionTypes.UPLOAD_FILES:
      return setUploadedFiles(state, action);
    case actionTypes.PAYER_DOCUMENTS:
      return setPayerDocs(state, action);
    case actionTypes.TOGGLE_CLICK:
      return setToggleClick(state, action);
    case actionTypes.LINK_ABHA_CLICK:
      return setLinkAbhaClick(state, action);
    case actionTypes.SET_FILE_DIALOG_OPEN:
      return setFileDialogOpen(state, action);
    case actionTypes.MAX_FILE_SIZE_ALLOWED:
      return setMaxSizeForFile(state, action);
    case actionTypes.MOBILE_ON_SCREEN:
      return setMobileOnScreen(state, action);
    case actionTypes.SHOW_SHARE_DOCUMENT_OPTIONS_MODAL:
      return setShowShareDocumentOptionsModal(state, action);
    case actionTypes.SET_NEW_HEALTHBANK_USER:
      return setHealthBankUser(state, action);
    case actionTypes.SET_SHOW_ABHA_LINK_MODAL:
      return setShowAbhaLinkModal(state, action);
    case actionTypes.SET_HEALTHBANK_USER_SIGNUP_OPTION:
      return setHealthbankUserSignupOption(state, action);
    case actionTypes.SET_DOCUMENT_UPLOAD_SUCCESS:
      return setDocumentUploadSuccess(state, action);
    case actionTypes.MOBILE_VERIFICATION:
      return setMobileVerification(state, action);
    case actionTypes.HEALTH_VAULT_ENABLE:
      return setHealthVaultEnable(state, action);
    case actionTypes.HEALTH_VAULT_DOCUMENT_UPLOAD:
      return setHealthVaultDocumentUpload(state, action);
    case actionTypes.SET_USER_PRESENT:
      return setUserPresent(state, action);
    case actionTypes.SET_USERS_NOT_FOUND:
      return setUsersNotFound(state, action);
    case actionTypes.SET_CHECK_ALL:
      return setCheckAllDocs(state, action);
    case actionTypes.ENABLE_AADHAR:
      return setEnableAadhar(state, action);
    case actionTypes.ENABLE_MOBILE_OTP:
      return setEnableMobileOTP(state, action);
    case actionTypes.ENABLE_AADHAAR_OTP:
      return setEnableAadhaarOTP(state, action);
    case actionTypes.SET_AADHAR_VERIFICATION_SUCCESS:
      return setAadharVerficationSuccess(state, action);
    case actionTypes.MOBILE_NO_VALUE:
      return setMobileNo(state, action);
    case actionTypes.TEMP_PROFILE:
      return setTempProfile(state, action);
    case actionTypes.SET_SELECTED_DOCTOR_LIST:
      return setSelectedDoctorList(state, action);
    case actionTypes.SET_PATIENT_SIGNATURE:
      return setPatientSignature(state, action);
    case actionTypes.MOBILE_OTP:
      return setMobileOTP(state, action);
    case actionTypes.AADHAAR_OTP:
      return setAadhaarOTP(state, action);
    case actionTypes.ENCRYPTED_NO_VALUE:
      return setEncryptedTxn(state, action);
    case actionTypes.TXN_ID:
      return setTxnId(state, action);
    case actionTypes.HOSP_ACTION_ID:
      return setHospActionId(state, action);
    case actionTypes.DOA_VALUE:
      return setDOA(state, action);
    case actionTypes.AADHAR_NO_VALUE:
      return setAadharNo(state, action);
    case actionTypes.IS_MINIMIZE:
      return setIsMinimize(state, action);
    case actionTypes.IS_SHOW_OTHER_MINIMIZE:
      return setShowOtherMinimize(state, action);
    case actionTypes.IS_MODAL:
      return setIsModal(state, action);
    case actionTypes.UPDATE_DRAFT_VALUE:
      return updateDraftValue(state, action);
    case actionTypes.SET_BILLAMOUNT_ARRAY:
      return setbillAmountArray(state, action);
    case actionTypes.SET_CLASSIFICATION_ARRAY:
      return setClassificationArray(state, action);
    case actionTypes.SET_USER_PROFILES:
      return setUserProfiles(state, action);
    case actionTypes.SET_UPLOADED_FILE_NAMES:
      return setFileNames(state, action);
    case actionTypes.SET_UPLOADED_FILE_GUID:
      return setFileGUID(state, action);
    case actionTypes.SET_UPLOADED_FILE_TYPES:
      return setFileTypes(state, action);
    case actionTypes.SET_UPLOADED_FILE_LIST:
      return setDocumentList(state, action);
    case actionTypes.SET_CHECKED_FILE_LIST:
      return setCheckedList(state, action);
    case actionTypes.NON_AVAILABLE_CLASSIFICATION:
      return setNonAvailableClassification(state, action);
    case actionTypes.FINALDOCS:
      return setFinalMandatoryClassifications(state, action);
    case actionTypes.IS_FILE_PROCESS_IN_PROGRESS:
      return setIsFileProcessInProgress(state, action);
    case actionTypes.SET_PERCENT:
      return setPercent(state, action);
    case actionTypes.GO_TO_NEXT:
      return setGoToNext(state, action);
    case actionTypes.CLICKED_ON_SKIP:
      return setClickedOnSkip(state, action);
    case actionTypes.PATIENT_CONSENT_PROCEED_CLICKED:
      return setPatientConsentProceedClicked(state, action);
    case actionTypes.SET_SELECTED_CONSENT_OPTION:
      return setSelectedConsentOptions(state, action);
    case actionTypes.SET_SELECTED_CONSENT_OPTION_STYLE:
      return setSelectedConsentOptionStyle(state, action);
    case actionTypes.SET_CONSENT_DATE_TIME:
      return setConsentDateTime(state, action);
    case actionTypes.IS_COME_FROM_SUBMIT:
      return setIsComeFromSubmit(state, action);
    case actionTypes.SET_IS_SUBMIT_CLICKED:
      return setIsSubmitted(state, action);
    case actionTypes.SET_IS_SUCCESS_MODAL_NEW_ADMISSION:
      return setIsSuccessModalNewAdmissionClicked(state, action);
    case actionTypes.UPDATE_PACKAGE_SELECTION:
      return updatePackageSelection(state, action);
    case actionTypes.SET_CARD_COLLAPSE:
      return setCardCollapse(state, action);
    case actionTypes.SET_EXTRA_FORM_VALUES:
      return setExtraFormValues(state, action);
    case actionTypes.IS_LOADING_PRE_DATA:
      return setIsLoadingPreData(state, action);
    case actionTypes.CLEAR_SELECTED_PACKAGE:
      return clearSelectedPackage(state, action);
    case actionTypes.MANUAL_SUBMISSION:
      return manualSubmissionEnable(state);
    case actionTypes.UPDATE_MEMBER_NAME:
      return setMemberName(state, action);
    case actionTypes.SET_IS_ABHA_ID_VERIFIED:
      return setAbhIdVerified(state, action);
    case actionTypes.MODAl_FORM_VALUES:
      return updateModalFormValues(state, action);
    case actionTypes.SET_IS_DRAFT_SELECTED:
      return setIsDraftSelected(state, action);
    case actionTypes.SET_SELECTED_DRAFT:
      return setSelectedDraftReducer(state, action);
    case actionTypes.SET_HOSPITAL_WISE_PAYER_LIST:
      return setHospitalWisePayerListReducer(state, action);
    case actionTypes.SET_IS_COMPONENT_RENDERED:
      return setIsComponentRendered(state, action);
    case actionTypes.SET_EXISTING_CLAIM_ERROR:
      return {
        ...state,
        existingClaimError: action.payload,
      };
    case actionTypes.SET_NEW_ADMISSION_SEARCH_VAL:
      return setNewAdmissionSearchValues(state, action);
    case actionTypes.SET_NEW_BILL_DETAIL_VAL:
      return setBillDetailValues(state, action);
    case actionTypes.GET_HEALTH_ID_CARD:
      return {
        ...state,
        getHealthIdCard: action.payload,
      };
    case actionTypes.SET_HEALTH_CARD_TYPE:
      return {
        ...state,
        healthCardType: action.payload,
      };
    case actionTypes.SET_IS_DISCHARGE_CASE:
      return {
        ...state,
        isDischargeCase: action.payload,
      };
    case actionTypes.SET_IS_COVID_CASE:
      return {
        ...state,
        isCovidCase: action.payload,
      };
    case actionTypes.DELAYED_ADMISSION:
      return {
        ...state,
        isDelayedAdmission: action.payload,
      };
    case actionTypes.SET_SUBMIT_WITHOUT_DOCS_CLICKED:
      return {
        ...state,
        submitWithoutDocsClicked: action.payload,
      };
    case actionTypes.LOSgt90:
      return {
        ...state,
        isLOSgt90: action.payload,
      };
    case actionTypes.SET_SELECTED_SEARCH_TYPE:
      return {
        ...state,
        searchType: action.payload,
      };
    case actionTypes.UPDATE_DEFAULT_TIMELINE:
      return {
        ...state,
        defaultTimeline: action.payload,
      };
    case actionTypes.DOWNLOAD_DOCUMENTS_GUIDS:
      return {
        ...state,
        downloadDocumentGuidList: action.payload,
      };
    case actionTypes.UPDATE_ADDITIONAL_MANDATORY_DOCS:
      return {
        ...state,
        additionalMandatoryDocuments: action.payload,
      };
    case actionTypes.UPDATE_AUTOMATED_PROCEDURE_OPTIONS:
      return {
        ...state,
        automatedProcedureOptions: action.payload,
      };
    case actionTypes.TOGGLE_OTHER_PROCEDURE:
      return {
        ...state,
        showOtherProcedure: action.payload,
      };
    case actionTypes.SET_PROBABILITY:
      return {
        ...state,
        showProbability: action.payload,
      };
    case actionTypes.SET_SELECTED_DISCREPENCY:
      return {
        ...state,
        selectedDiscrepency: action.payload,
      };
    case actionTypes.SET_NON_SELECTED_DISCREPENCY:
      return {
        ...state,
        nonSelectedDiscrepency: action.payload,
      };
    case actionTypes.HID_CONFIRMATION:
      return {
        ...state,
        hidConfirmationMessage: action.payload,
      };

    case actionTypes.FETCH_ABHA_VERIFICATION_METHODS_SUCCESS:
      return {
        ...state,
        abhaAuthModeFail: false,
        abhaAuthModes: action?.payload?.modes || initialState.abhaAuthModes,
      };

    case actionTypes.FETCH_ABHA_VERIFICATION_METHODS_FAILURE:
      return {
        ...state,
        abhaAuthModeFail: true,
        abhaAuthModes: initialState.abhaAuthModes,
      };

    case actionTypes.ABHA_VERIFICATION_SENT_OTP:
      return {
        ...state,
        isLoadingAuthenticate: true,
      };

    case actionTypes.ABHA_VERIFICATION_SENT_OTP_SUCCESS:
      return {
        ...state,
        txnId: action?.payload || initialState.txnId,
        abhaIdOtpVerificationError: false,
        isLoadingAuthenticate: false,
      };

    case actionTypes.ABHA_VERIFICATION_SENT_OTP_FAILURE:
      return {
        ...state,
        isLoadingAuthenticate: false,
      };

    case actionTypes.ABHA_CONFIRM_OTP_SUCCESS: {
      return {
        ...state,
        abhaIdVerifiedData: action?.payload || initialState.abhaIdVerifiedData,
        abhaIdOtpVerificationError: false,
      };
    }

    case actionTypes.ABHA_CONFIRM_OTP_ERROR: {
      return {
        ...state,
        abhaIdOtpVerificationError: true,
      };
    }

    case actionTypes.CREATE_ABHA_ALREADY_EXIST:
      return {
        ...state,
        createAbhaAlreadyExist: action?.payload || initialState.createAbhaAlreadyExist,
      };

    case actionTypes.SET_FORM_ACTION:
      return {
        ...state,
        formAction: action.payload,
      };
    case actionTypes.UPDATE_BILL_DETAILS:
      return updateBillFields(state, action);
    case actionTypes.UPDATE_ADMISSION_START_TIME:
      return {
        ...state,
        additionalAdmissionInfo: {
          ...state.additionalAdmissionInfo,
          admissionStartTime: action.payload,
        },
      };
    case actionTypes.CHANGE_FORM_TYPE:
      return {
        ...state,
        admissionFormType: action.payload,
      };
    case actionTypes.TOGGLE_ENABLE_FILE_UPLOAD_FORCE:
      return {
        ...state,
        isFileUploadEnabledForce: action.payload,
      };
    case actionTypes.RESET_DETAIL_NAV:
      return {
        ...state,
        resetDetailNav: state.resetDetailNav + 1,
      };
    case actionTypes.TOGGLE_CSV_MISMATCH:
      return {
        ...state,
        showCsvMismatchModal: action.payload,
      };
    case actionTypes.CSV_RETRY:
      return {
        ...state,
        submitWarn: action.payload,
      };
    case actionTypes.UPDATE_SELECTED_CENTER:
      return {
        ...state,
        selectedCenter: action.selectedCenter,
      };
    case actionTypes.SET_DOB_LOADING:
      return {
        ...state,
        dobLoading: action.payload,
      };
    case actionTypes.DOB_MODAL_VISIBLE:
      return {
        ...state,
        dobModalVisible: action.payload,
      };
    case actionTypes.SET_DL_VERIFIED:
      return {
        ...state,
        dlVerified: action.payload,
      };
    case actionTypes.SET_VOTERID_VERIFIED:
      return {
        ...state,
        voterIDVerified: action.payload,
      };
    case actionTypes.SET_AUTO_POPULATE_DAY_CARE_TOGGLE:
      return {
        ...state,
        autoFillDayCareProcedure: action.payload,
      };
    case actionTypes.TOGGLE_OTHER_ROOM_TYPE:
      return {
        ...state,
        showOtherRoomType: action.payload,
      };
    case actionTypes.SET_HOSP_DETAILS_FOR_ROOM_TYPE:
      return {
        ...state,
        hospDetailsForRoomType: action.payload,
      };
    case actionTypes.HOSPITAL_OTHER_ROOM_TYPE:
      return {
        ...state,
        hospitalOtherRoomType: action.payload,
      };
      case actionTypes.SET_STATUS_NAME:
        return {
          ...state,
          statusName: action.payload,
        };
    case actionTypes.DISABLE_ROOM_TYPE:
      return {
        ...state,
        disableRoomType: action.payload,
      };
    case actionTypes.SET_SETTLEMENT_TYPE:
      return {
        ...state,
        settlementType: action.payload,
      };
    case actionTypes.SET_ADHAAR_LOADING:
      return {
        ...state,
        adhaarLoading: action.payload,

      };
    case actionTypes.OTP_MODAL_VISIBLE:
      return {
        ...state,
        verificationModalVisible: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION:
      return {
        ...state,
        selectedOption: action.payload,
      };
    case actionTypes.SET_AADHAAR_RESPONSE:
      return {
        ...state,
        aadhaarResponse: action.payload,
      };
    case actionTypes.SET_SUCCESS_MODAL:
      return {
        ...state,
        successModalVisible: action.payload,
      };
    case actionTypes.SET_IS_DOA_DOD_ENHANCEMENT_MODAL_OPEN:
      return {
        ...state,
        isShowingDoADoDEnhancementModal: action.payload,
      };
    case actionTypes.SET_ADHAAR_VERIFIED:
      return {
        ...state,
        adhaarVerified: action.payload,
      };
    case actionTypes.SET_NAME_ADHAAR_VERIFIED:
      return {
        ...state,
        nameAdhaarVerified: action.payload,
      };
    case actionTypes.SET_PAN_VERIFIED:
      return {
        ...state,
        panVerified: action.payload,
      };
    case actionTypes.SET_PAN_NO_VERIFIED:
      return {
        ...state,
        panNoVerified: action.payload,
      };
    case actionTypes.SET_PAGE_CHANGE_ALLOWED:
      return {
        ...state,
        isPageChangeAllowed: action.payload,
      };
    case actionTypes.SET_DYNAMIC_QUESTION_FIELDS:
      return {
        ...state,
        dynamicQuestionFields: action.payload,
      };
    case actionTypes.SET_SPECIALITY_OPTIONS:
      return {
        ...state,
        specialityOptions: action.payload,
      };
    case actionTypes.SET_PAN_NUMBER:
      return {
        ...state,
        panCardNumber: action.payload,
      };
    case actionTypes.SET_PAN_REQUIRED:
      return {
        ...state,
        panRequired: action.payload,
      };

    case actionTypes.IS_PLT_CHANGED:
      return {
        ...state,
        isPLTChanged: action.payload,
      };
    case actionTypes.SET_AILMENT_VALUE:
        return{
          ...state,
          ailmentValue: action.payload,
        };
    case actionTypes.SET_BUDDHIMED_SELECTED_FILES:
      return {
        ...state,
        selectedFiles: action.payload,
      };
    case actionTypes.SET_PREVIOUSLY_UPLOADED_FILES:
      return {
        ...state,
        previouslyUploadedFiles: action.payload,
      };
    case actionTypes.SET_SUBMIT_DISABLED:
        return{
          ...state,
          submitDisabled: action.payload,
        };
    case actionTypes.PLT_MAPPED_VALUE:
      return {
        ...state,
        pltMappedValue: action.payload,
      };
    case actionTypes.SET_PAYER_ROOM_TYPE:
      return {
        ...state,
        ...{
          admissionFormVal: {
            ...state.admissionFormVal,
            treatmentDetail: {
              ...state.admissionFormVal.treatmentDetail,
              payerRoomType: action.payload,
            },
          },
        },
      };
    case actionTypes.SET_BENEFICIARY_POPUP_FLAG:
      return {
        ...state,
        isBeneficiaryPopUpRequired: action.payload,
      };
    case actionTypes.SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_ID:
      return {
        ...state,
        beneficiarySearchResponsePayerId: action.payload,
      };
    case actionTypes.SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_NAME:
      return {
        ...state,
        beneficiarySearchResponsePayerName: action.payload,
      };
    case actionTypes.SET_SHOW_PAYER_NOT_CONFIGURED_MSG:
      return {
        ...state,
        showPayerNotConfiguredMessage: action.payload,
      };
    case actionTypes.SET_SHOW_PAYER_UPDATED_MSG:
      return {
        ...state,
        showPayerUpdatedMessage: action.payload,
      };
    case actionTypes.SET_SHOW_BENEFICIARY_CARD:
      return {
        ...state,
        showBeneficiaryCard: action.payload,
      };
    case actionTypes.SET_MODAL_SWITCH:
      return{
        ...state,
        modalSwitchDisabled : action.payload,
      };
    case actionTypes.ENABLE_IPNUMBER_POPUP:
      return {
        ...state,
        isIPNumberPopUpEnabled: action.payload,
      };
    case actionTypes.SET_SUBMIT_DISABLED:
      return {
        ...state,
        submitDisabled: action.payload,
      };
    case actionTypes.SET_MODAL_SWITCH:
      return{
        ...state,
        modalSwitchDisabled: action.payload,
      };
    case actionTypes.SET_PAN_VERIFICATION_REQUIRED:
      return{
        ...state,
        panVerificationRequired: action.payload,
      };
    case actionTypes.SET_DRAFT_FORM_VALIDATED:
      return{
        ...state,
        draftFormValidated: action.payload,
      };
    case actionTypes.SET_SHOW_ACCIDENT_CARD:
      return{
        ...state,
        showAccidentCard: action.payload,
      };
      case actionTypes.SET_CONDITION_ON_DISCHARGE:
        return {
          ...state,
          conditionOnDischargeValue: action.payload,
        };
      case actionTypes.SET_HOURS_DIFFERENCE:
        return{
          ...state,
          hospitalizationDuration: action.payload,
        };
      case actionTypes.SET_DATE_APPLIED:
        return{
          ...state,
          isDateApplied: action.payload,
        };
      case actionTypes.SET_NEW_BORN_CASE:
        return{
          ...state,
          isNewBornCase: action.payload,
        };
      case actionTypes.SET_MEMBER_SEARCH_ID:
        return{
          ...state,
          memberSearchId: action.payload,
        };
      case actionTypes.SET_SELECTED_MEMBER_CARD:
        return{
          ...state,
          selectedMemberCardIndex: action.payload,
        };
      case actionTypes.SET_MEMBER_ID:
        return{
          ...state,
          memberId: action.payload,
        };
      case actionTypes.SET_PERCENTAGE_NAME_MATCH:
        return{
          ...state,
          percentageNameMatch: action.payload,
        };
    case actionTypes.SET_IS_DEATH_CASE:
      return {
        ...state,
        isDeathCase: action.payload,
      };
    case actionTypes.SET_DIAGNOSIS_FROM_PAYER_LOOKUP:
      const appenedDiagnosisValues = state?.diagnosisSelectedValues || [];
      appenedDiagnosisValues?.push(action?.payload);
      return {
        ...state,
        diagnosisSelectedValues: appenedDiagnosisValues,
      };
    case actionTypes.SET_PROCEDURE_FROM_PAYER_LOOKUP:
      const appenedProcedureValues = state?.procedureSelectedValues || [];
      appenedProcedureValues?.push(action?.payload);
      return {
        ...state,
        procedureSelectedValues: appenedProcedureValues,
      };
    case actionTypes.SET_GOVT_SCHEME_URN:
      return{
        ...state,
        govtSchemeUrn: action.payload,
      };
    case actionTypes.SET_DEFAULT_CLAIM:
      return {
        ...state,
        defaultClaim: action.payload,
      };
    case actionTypes.SET_HIS_SELECTED_FILES:
      return {
        ...state,
        selectedHISFiles: action.payload,
      };
    case actionTypes.SET_HIS_CHECKED_FILES:
      return {
        ...state,
        checkedHISFiles: action.payload,
      };
    case actionTypes.SET_UPDATED_LETTERS:
      return {
        ...state,
        updatedVisibleLetters: action.payload,
      };
    case actionTypes.SET_FILES:
      return {
        ...state,
        updatedFiles: action.payload,
      };
    case actionTypes.SET_HIS_FILE_SIZE:
      return {
        ...state,
        hisFileSize: action.payload,
      };
    case actionTypes.SET_DAYCARE_CASE:
      return {
        ...state,
        isDaycareCase: action.payload,
      };
    case actionTypes.SET_ALLOW_NEXT_STAGE:
      return {
        ...state,
        allowNextStage: action.payload,
      };
    case actionTypes.SET_STAR_DISABLED_BENEF_MESSAGE:
      return {
        ...state,
        starDisabledBenefMessage: action.payload,
      };
    case actionTypes.SET_SUBMIT_BTN_FROM_MODAL:
      return {
        ...state,
        isSubmiClickedFromModal: action.payload,
      };
    case actionTypes.SET_HYPHENATED_GROUP:
      return {
        ...state,
        hyphenatedBasedGroupPolicy: action.payload,
      };
        case actionTypes.SET_IS_ARTEMIS:
      return {
        ...state,
        isArtemis: action.payload,
      };
    default: return state;
  }
};

export { reducer as newAdmissionReducer };
